import React from "react"
import { Card, Col, ProgressBar, Row } from "react-bootstrap"
import "./styles.css"
const ShowResultados = ({ resultados, isClosed }) => {
	return (
		<Card>
			<Card.Body>

				{
				isClosed ?
				resultados?.votos.map((c, index) => {
					return (
						<Row className="row-candidato" key={index}>
							<Col lg={4}>
								<span className="nombre-candidato">{c.nombre}</span>
							</Col>
							<Col lg={6}>
								<span className="progress-bar-votos">
									<ProgressBar now={c.validos} max={resultados.padron} min={0} variant="info" />
								</span>
							</Col>
							<Col lg={2}>
								<span className="votos-contador">{c.validos}</span>
							</Col>
						</Row>
					)
				}):
				<h5>El detalle de los resultados estará disponible una vez cerrada la votación</h5>
				}
        <hr/>
        <Row>
					<Col>VÁLIDOS: {resultados?.validos}</Col>
          <Col>BLANCOS: {resultados?.blancos}</Col>
          <Col>NULOS: {resultados?.nulos}</Col>
        </Row>
        <hr/>
        <Row>
          <Col>
          Total Votos Emitidos: <b>{resultados?.asistencia}</b> <br/> 
          Total Registros en Padrón: <b>{resultados?.padron}</b>
          </Col>
        </Row>
			</Card.Body>
		</Card>
	)
}

export default ShowResultados
